module.exports = __webpack_public_path__ + "img/no-goods.190e2f94.svg";